
export class LoggingModel {
    public constructor(id:string,message:string) {
        this.id = id;
        this.message = message;
    }

    public id: any;
    public message: string;
}


export class LoggingGroupModel {
    public constructor(id:string,messages:string[]) {
        this.id = id;
        this.messages = messages;
    }

    public id: any;
    public messages: string[];
}
